const locale = {
    global: {
        entities: {
            lead: "Лид",
            deal: "Сделка"
        },
        days: {
            mon: "Пн",
            tue: "Вт",
            wed: "Ср",
            thu: "Чт",
            fri: "Пт",
            sat: "Сб",
            sun: "Вс"
        },
        months: {
            short: {
                1: "Янв",
                2: "Фев",
                3: "Мар",
                4: "Апр",
                5: "Май",
                6: "Июн",
                7: "Июл",
                8: "Авг",
                9: "Сен",
                10: "Окт",
                11: "Ноя",
                12: "Дек"
            },
            full: {
                1: "Январь",
                2: "Февраль",
                3: "Март",
                4: "Апрель",
                5: "Май",
                6: "Июнь",
                7: "Июль",
                8: "Август",
                9: "Сентябрь",
                10: "Октябрь",
                11: "Ноябрь",
                12: "Декабрь"
            }
        },
        cancel: "Отмена",
        close: "Закрыть",
        save: "Сохранить",
        add: "Добавить",
        change: "Изменить",
        prev_step: "Предыдущий шаг",
        next_step: "Следующий шаг",
        create: "Создать",
        select: "Выбрать",
        loading: "Загрузка...",
        "no-data": "Нет данных",
        "no-results": "Ничего не найдено",
        delete: "Удалить",
        yes: "Да",
        no: "Нет",
        parent: "Родитель",
        editing: "Изменение",
        adding: "Добавление",
        confirm: "Подтвердите действие",
        date: "Дата",
        time: "Время",
        duration: "Длительность",
        status: "Статус",
        deal: "Сделка",
        lead: "Лид",
        install: "Установить",
        continue: "Продолжить"
    },
    install: {
        title: "Установка приложения",
        block1: "При установки данного приложения, будут установленны таблицы, необходимые для работы приложения, базовые настройки, а так же поля, в которых будет храниться информация записи.",
        block2: "Данные изменения обратимы, однако стоит обратить внимание, что при удалении приложения заполненные справочники (заполняются в приложении) не сохраняться.",
        block3: "Данные сохраненные в лидах/сделках останутся без изменений.",
        error_button: "Есть ошибки. Подробности в консоли",
        error_more: "Произошли ошибки. Не закрывая данное сообщение вы можете просмотреть их в консоли. Установка будет продолжена.",
        demo: {
            1: {
                name: "Основной филиал",
                detail: "Для работы приложения нужен как минимум 1 филиал. Например, филиал на ул. Пушкина 22/1",
            },
            2: {
                name: "Направление 1",
                detail: "Демо направление приложения. Например, терапия",
            },
            3: {
                name: "Направление 2",
                detail: "Демо направление приложения. Например, травматология",
            },
            4: {
                name: "Кабинет 1",
                detail: 'Реальный кабинет в котором работает сотрудник. Например, "№415"',
            },
            5: {
                name: "Кабинет 2",
                detail: 'Реальный кабинет в котором работает сотрудник. Например, "№415"',
            },
            6: {
                name: "Сотрудник 1",
                detail: 'Сотрудник. Например, Петр Иванович',
            },
            7: {
                name: "Сотрудник 2",
                detail: 'Сотрудник. Например, Петр Иванович',
            },
        }
    },
    errors: {
        default: "Произошли ошибки. Подробности в консоли",
        no_finded_filial: 'Необходимо создать хотя бы один филиал в разделе \"Справочники\"',
        no_use_timezone_lead: 'У поля даты записи в лидах, должна СНЯТА галочка \"Использовать часовые пояса\"',
        no_use_timezone_deal: 'У поля даты записи в сделках, должна СНЯТА галочка \"Использовать часовые пояса\"',
        no_user_uf_department: 'Не нашел у пользователя поле Подразделение (UF_DEPARTMENT)',
        no_fieldsForAutofield: "В строке #{number} поле не выбрано.",
        multiple_fieldsForAutofield: "Поле {field} определено несколько раз.",
        filial_required: "Должен быть выбран хотя бы один филиал.",
        widget_not_found: "Не смог распознать текущую форму",
        video_connection_error: "Произошла ошибка соединения",
        element_has_links: "Невозможно удалить элемент. На него ссылается {count} объект(ов).",
        change_avatar_error: "Не смог преобразовать изображение.",
        no_filial_selected: "Необходимо указать привязку к филиалу",
        avatar_size_error: "Размер изображения должен быть не больше 2 MB.",
        phone_error: "Номер телефона не определен.",
        time_error: "Ошибка распланированного врмени. Обновите страницу.",
        spec_busy: "Данный {who} уже забронирован на {when}",
        spec_busy_2: "Данный специалист уже забронирован c {from} по {to} в {where}",
        calendar_no_data: "Нет данных для отображения. Сотрудники не распределены.",
        resource_error: "Не смог получить ресурс",
        period_error: "Период не определен",
        startTime_error: "Проверьте настройки времени начала рабочего дня.",
        duration_zero_error: "Длительность визита заполнена не корректно.",
        action_error: "Не смог определить действие. Проверьте настройки. Возможно не указано что создаем, лид или сделку.",
        no_contact_create: "Контакт не выбран. Создам новый контакт.",
        invalid_phone: "Номер не корректный",
        invalid_online_token: "Некорректные параметры формы",
        field_not_filled: "Поле не заполнено",
        invalid_phone_length: "Превышена длина номера",
        invalid_phone_symbols: "Номер содержит недопустимые символы"
    },
    messages: {
        success: "Успешно",
        fields_created: "Поля успешно созданы",
        saved: "Сохранено успешно",
        widget_published: "Успешно опубликовано",
        status_changed: "Статус успешно изменен",
        widget_deleted: "Виджет успешно удален",
        element_deleted: "Элемент успешно удален"
    },
    main: {
        calendar: {
            new_element: "Новая запись",
            developed_in: "Разработано в",
            title: "Расписание специалистов",
            no_data: "Нет данных для отображения. Укажите фильтры.",
            tags: {
                filial: "Запись находится в другом филиале",
                group: "Запись находится в другом подразделении",
                resource: "Запись находится в другом кабинете"
            },
            types: {
                spec: "специалист",
                resource: "ресурс"
            },
            filter: {
                tooltip: "Фильтр",
                public_filters: "Общие фильтры",
                personal_filters: "Личные фильтры",
                no_filters: "Нет фильтров",
                delete_filter: "Удалить фильтр",
                filter_name: "Название фильтра",
                edit_filters: "Редактировать фильтры",
                save_changes: "Сохранить изменения",
                add_as_public: "Добавить фильтр как общий",
                add_as_personal: "Добавить фильтр как личный",
                select_all: "Выбрать все",
                select_contact: "Выбор контакта",
                saved_successfully: "Фильтры успешно сохранены",
                select_filters: "Укажите параметры фильтрации справа"
            },
            panel: {
                weekday: "Отображать расписание на неделю",
                hide_status_on: "Скрытые не отображаются",
                hide_status_off: "Скрытые отображаются",
                duplicate: "Дублировать расписание",
                start_editing: "Начать редактирование",
                end_editing: "Закончить редактирование",
                notifications: "Уведомления",
                no_notifications: "Нет уведомлений"
            },
            gridMulti: {
                confirm_delete: "Вы действительно хотите удалить данный элемент?"
            },
            contextMenu: {
                create: "Создать запись",
                open: "Открыть",
                edit: "Изменить",
                move: "Переместить",
                call: "Позвонить",
                copy_wo: "Копировать (без услуг)",
                copy_w: "Копировать (с услугами)",
                paste: "Вставить",
                change_stage: "Изменить стадию",
                change_status: "Изменить статус"
            },
            modalBron: {
                date: "Дата записи",
                time: "Время записи",
                service: "Услуга",
                duration: "Продолжительность в минутах",
                phone: "Номер телефона",
                last_name: "Фамилия",
                name: "Имя",
                second_name: "Отчество",
                founded_contacts: "Найденные контакты",
                listVisit: "История записей"
            },
            doubleBron: {
                title: "Дублирование расписания на дальнейшие дни",
                duplicate: "Дублировать",
                
            }
        },
        fields: {
            crm_cm: "Количество минут",
            crm_dt: "Дата записи",
            crm_pr: "Подразделение (расписание)",
            crm_kb: "Кабинет (расписание)",
            crm_st: "Сотрудник (расписание)",
            crm_fl: "Филиал (расписание)",
            product_cm: "Время в минутах на услугу",
            entity_cb_type: "Тип",
            entity_cb_calendar: "Календарь",
            entity_cb_group: "Направление",
            entity_cb_specialist: "Специалист",
            entity_cb_color: "Цвет",
            entity_cb_user: "Пользователь",
            entity_cb_department: "Подразделение",
            entity_cb_catalog: "Каталог",
            entity_cb_product: "Услуга",
            entity_cb_cardFields: "Поля для сущности",
            entity_cb_scrolling: "Скроллинг",
            entity_cb_filials: "Филиал",
            entity_cb_avatar: "Фото сотрудника",
            entity_cb_geo: "Координаты",
            entity_cb_schedules: "График работы",
            entity_rc_resours: "Кабинет",
            entity_rc_timeStart: "Время начала",
            entity_rc_timeEnd: "Продолжительность (интервалов)",
            entity_rc_entity: "Сотрудник",
            entity_rc_date: "Дата",
            entity_rc_group: "Подразделение",
            entity_rc_filial: "Филиал"
        },
        menu: {
            calendar: "Календарь",
            dictionary: "Справочники",
            videos: "Видео-уроки",
            settings: "Настройки"
        },
        tables: {
            title: "Справочники",
            delete: {
                title: "Удалить?",
                subtitle: "Вы действительно хотите удалить выбранный элемент?"
            },
            headers: {
                name: "Наименование",
                department: "Подразделение",
                catalog: "Каталог"
            },
            modal: {
                create: "Создание элемента",
                edit: "Редактирование элемента",
                name: "Наименование",
                crm_user: "Пользователь в CRM:",
                photo: {
                    label: "Фото",
                    hint: "Изображение выводится в онлайн форме. Рекомендуется использовать квадратное изображение.",
                    subtitle: "Рекомендуется использовать небольшие изображения, так как они будут выводиться только в виджете."
                },
                description: "Краткое описание",
                department: "Подразделение",
                catalog: {
                    label: "Каталог товаров",
                    hint: "Выберите только корневые каталоги. Подкаталоги учитываются автоматически."
                },
                color: "Цвет в календаре",
                geoString: "Координаты филиала",
                fieldsForEntityRadio: {
                    label: "Вывод полей:",
                    default: "По умолчанию",
                    custom: "Особый",
                    fields: "Выводимые поля"
                },
                scrollingForCurrent: {
                    label: "Скроллинг для текущей группы:",
                    default: "По умолчанию",
                    disable: "Отключен",
                    enable: "Включен"
                },
                schedules: {
                    label: "График работы",
                    title: "Все графики",
                    empty: "Нет графиков...",
                    schedule: {
                        title: "{action} график работы",
                        name: "Название графика",
                        dateFrom: "Дата начала активности",
                        dateTo: "Дата окончания активности",
                        groups: "Направление",
                        filials: "Филиал",
                        exceptions: "Исключения",
                        intervals: "Интервалы",
                        work: "Рабочий день",
                        free: "Выходной",
                        days: "Дней",
                        days_count: "Кол-во дней"
                    }
                }
            },
            directory: "Справочник"
        },
        video: {
            title: "Видео",
        },
        settings: {
            title: "Настройки",
            gridCalendar: {
                defaultLanguage: "Язык",
                menu: "Сетка календаря",
                title: "Настройки сетки календаря",
                days: "Дни недели для отображения",
                useResource: "Использовать ресурсы",
                allowRecordOneSotr: "Разрешить записывать одного сотрудника на одно и то же время в разные кабинеты",
                allowRecordOneRes: "Разрешить запись в один кабинет нескольких сотрудников",
                scrollableCalendar: "Скроллинг календаря",
                use_spec_user: "Использовать пользователя специалиста как ответственного",
                widthColumn: "Ширина колонки в пикселях",
                fontSizeTitle: "Размер шрифта в заголовках карточек",
                fontSize: "Размер шрифта в теле карточек",
                workDay: "Рабочие часы",
                startWorkDay: "Начало рабочего дня",
                endWorkDay: "Конец рабочего дня",
                sizeGrid: "Размер сетки",
                sizeGrid_hint: "Размер сетки указывается в минутах",
                labelFilials: "Подпись филиалов",
                labelGroup: "Подпись направлений",
                labelGroup_hint: "Направление - верхняя группа для записи. У вас это может быть профиль, группа и т.д.",
                labelSpecialist: "Подпись специалиста",
                labelSpecialist_hint: "Специалист - второй уровень групп. У вас это может быть парикмахер, замерщик, грузчик, врач и т.д.",
                labelProduct: "Подпись услуг",
                labelProduct_hint: "Услуги - третий уровень. У вас это может быть услуга, причина посещения, работа и т.д.",
                labelResourse: "Подпись ресурса"
            },
            writeCrm: {
                menu: "Параметры записи",
                title: "Параметры записи",
                entity: "Сущность",
                dealCategory: "Направление сделки по умолчанию",
                selectedUsers: "Пользователи которых считать модераторами",
                hideStatus: "Скрываемые статусы/стадии",
                hideStatus_hint: "Скрываемые статусы/стадии",
                lead_fields: "Выбор полей лида",
                deal_fields: "Выбор полей сделки",
                fieldDateWrite: "Дата записи",
                fieldDateWrite_hint: 'Поле типа "Дата/Вермя" для хранения времени записи.',
                fieldCountMinut: "Продолжительность приема",
                fieldCountMinut_hint: 'Поле типа "Число", для записи продолжительности в минутах.',
                fieldTitleCalendar: "Поле для отображение в календаре",
                fieldTitleCalendar_hint: 'Поле типа "Строка" для вывода в календаре сотрудников. Можете формировать используя бизнес-процессы.',
                fieldProductTime: "Время на услугу",
                fieldProductTime_hint: "Поле в товаре. Время затрачиваемое на услугу.",
                fieldDateWriteConvertedDeal: "Дата записи в сделке",
                fieldDateWriteConvertedDeal_hint: 'Поле типа "Дата/Вермя" в которое будет записана дата из лида, после конвертации.',
                fieldCountMinutConvertedDeal: "Продолжительность приема",
                fieldCountMinutConvertedDeal_hint: 'Поле типа "Число", для записи продолжительности в минутах.',
                sort_index: "Параметры записи",
                sort_index_users: "Отображать для сотрудников",
                status_color_title: "Цвета по статусам",
                status_color_subtitle: "Вы можете указать произвольные цвета для конкретных статусов.",
                status_color: "Статус/стадия",
                status_color_hint: "Цвет для статуса/стадии"
            },
            writeCrmAutoField: {
                menu: "Автозаполнение полей BETA",
                warning: 'ВНИМАНИЕ! Данные настройки зависят от типа сущности CRM выбранной в пункте "Параметры записи". Рекомендуется сначала настроить предыдущий пункт.',
                title: "В текущей реализации, мы предлагаем заполнять СТРОКОВЫЕ, НЕ МНОЖЕСТВЕННЫЕ поля.",
                saveAdd: "Использовать автозаполнение при создании",
                saveUpdate: "Использовать автозаполнение при изменении",
                empty: "Поля автоматически не заполняются",
                autoField: "Поле для автоматического заполнения",
                autoField_value: "Значение",
                fields_menu: "Меню значений для вставки",
                autoField_remove: "Удалить поле для автозаполнения",
                autoField_add: "Добавить поле для автозаполнения",
                variables: {
                    app: {
                        title: "Переменные приложения",
                        productName: "Товар",
                        filialCode: "Код филиала",
                        filialName: "Наименование филиала",
                        sotrCode: "Код сотрудника",
                        sotrName: "ФИО сотрудника",
                        podrCode: "Код подразделения",
                        podrName: "Наименование подразделения",
                        resourceCode: "Код кабинета",
                        resourceName: "Наименование кабинета",
                        recordTime: "Время записи",
                        recordDate: "Дата записи",
                        recordCountMinut: "Количество минут приема"
                    },
                    contact: "Значения контакта",
                    lead: "Значения лида",
                    deal: "Значения сделки"
                }
            },
            fixBug: {
                menu: "Служебные операции",
                title: "Обработки данных для приложения",
                subtitle: "Ниже собраны действия, выполнение которых требуется если работа приложения была нарушена. Используйте кнопки ниже, для восстановления работы приложения.",
                event_log: "Лог событий",
                fields_recovery: "Восстановление полей",
                fields_recovery_subtitle: "В случае если по какой-то причине служебные поля приложения были удалены, их можно восстановить при помощи данной обработки:",
                fields_recovery_button: "Восстановить поля",
                migration: "Перенос из старого формата в новый",
                migration_desc: `Мы в корне изменили подход к привязке сделок/лидов. Раньше мы хранили идентификатор распределенного отрезка времени в сделке, теперь в сделке хранятся идентификаторы 
                кабинета, сотрудника и подразделения. Это позволяет решить ряд задач, решение которых ранее было проблематичным (например перенос из другой системы).
                После проведения операции, пользовательское поле "Ресурс календаря (не удалять)" можно будет удалить (CRM - Настройки - Настройки форм и отчетов - Пользовательские поля).
                ВАЖНО! Не удаляйте поле, если перенос данных из старого формата в новый не удался, и записи в календаре не появились.`,
                migration_button: "Выполнить конвертацию форматов",
                filials: "Вводим филиалы",
                filials_desc: "Так как раньше филиалов у нас не было, после обновления у вас пропали все распеределения сотрудников. Нажмите кнопку ниже и дождитесь завершения - мы все исправим.",
                filials_label: "Филиал для подстановки",
                filials_hint: "Данный филиал будет подставлен во все распределения времени.",
                filials_button: "Выполнить заполнение филиала"
            },
            onlineForm: {
                menu: "Онлайн запись BETA",
                title: "Список событий вызываемых для аналитики в Яндекс Метрике и Гугл Аналитике:",
                main: {
                    title: "Ваши онлайн формы:",
                    empty: "У вас пока нет форм.",
                    add: "Добавить новую форму"
                },
                stepper: {
                    steps: {
                        MainSettings: "Основные настройки",
                        Design: "Оформление",
                        Public: "Публикация"
                    },
                    MainSettings: {
                        vidgetName: "Наименование виджета",
                        noSelectDate: "Не предоставлять пользователям возможность выбора времени для записи (распределяет менеджер)",
                        noSelectTime: "Не выбирать автоматически первое доступное время при выборе даты в виджете",
                        noSelectProduct: "Убрать выбор услуги в виджете",
                        widgetMinutes: "Время в минутах на запись без услуги",
                        countProduct: "Максимум товаров на заявку",
                        countProduct_hint: "0 - количество не ограничено",
                        statusForHide_lead: "Статусы лидов не учитываемые при отображении загруженности",
                        statusForHide_deal: "Стадии сделок не учитываемые при отображении загруженности",
                        vidgetPhone: "Настройки номера телефона",
                        selectedNumberPrefix: "Отображаемые в форме префиксы стран",
                        defaultPrefix: "Префикс по умолчанию",
                        vidgetFilial: "Филиалы для текущего виджета",
                        filials: "Филиалы",
                        vidgetFields: "Поля отображаемые в форме",
                        vidgetFields_desc: "Дополнительные поля, которые будут выводиться в форме записи. Не обязательно к заполнению.",
                        field_label: "Представление поля",
                        field_name: "Поле",
                        field_text: "Текст подсказки",
                        vidgetProductProps: "Свойства товаров отображаемые в виджете",
                        vidgetAnalytics: "Подключить аналитику:",
                        yandexId: "Яндекс Метрика",
                        yandexId_hint: "Идентификатор счетчика яндекс метрики",
                        googleId: "Google Analytics",
                        googleId_hint: "Идентификатор отслеживания ресурса Google Аналитики",
                        onlyInt: "Значение должно быть числом"
                    },
                    Design: {
                        embed: "Вид встраивания виджета на сайт:",
                        embed_frame: "Встраивание в виде фрейма",
                        embed_button: "Встраивание в виде кнопки",
                        embed_vidget: "Встраивание в виджет Bitrix24",
                        embed_href: "Ссылка на онлайн запись",
                        button_title: "Настройки для кнопки",
                        positionForButton: "Положение кнопки",
                        colorButton: "Цвет кнопки",
                        general: "Общие настройки интерфейса",
                        darkTheme: "Тёмная тема",
                        logoSrc: "Ссылка вида https://site.com/image.jpg",
                        logoSrc_hint: "Адрес логотипа",
                        fieldStyle: "Вид полей ввода",
                        testField: "Пример поля для отображения",
                        testField_hint: "Подсказка будет выглядеть так",
                        outland: "Внешнии линии",
                        shaped: "Закругленный верх",
                        rounded: "Закругленные углы",
                        solo: "Минималистичный стиль",
                        clearable: "Значок очистить",
                        presentHint: "Показывать подсказку всегда",
                        colorField: "Цвет поля ввода",
                        lt: "Левый верхний угол",
                        rt: "Правый верхний угол",
                        lb: "Левый нижний угол",
                        rb: "Правый нижний угол"
                    },
                    Public: {
                        title: "Публикация виджета",
                        subtitle: "Код для вставки на сайт будет готов только после публикации. Если вы будете вносить изменения в виджет, не забывайте повторно его опубликовать.",
                        deleteWidget: "Удалить виджет",
                        publishWidget: "Опубликовать",
                        widgetCode: "Вставьте этот код перед закрывающим тегом body:",
                        iframeCode: "Ваш iframe формы:",
                        linkCode: "Ваша ссылка:"
                    }
                },
                myWebStor_createWidget: "при загрузке виджета",
                myWebStor_setFilial: "выбран филиал",
                myWebStor_changeNapravl: "изменено направление",
                myWebStor_changeSotr: "изменен сотрудник",
                myWebStor_changeProduct: "изменен список продкутов",
                myWebStor_changeDate: "изменена дата",
                myWebStor_selectTime: "выбрано время",
                myWebStor_stepSetNapr: "перешел на шаг выбора направлений",
                myWebStor_stepInputPersonalData: "перешел на шаг ввода персональных данных",
                myWebStor_errorSendForm: "ошибка отправки формы",
                myWebStor_successSendForm: "удачная отправка формы",
                myWebStor_ErrorGettingDate: "ошибка получения информации о загруженности (так же возникает если расписание не распланировано)",
                myWebStor_SuccessErrorGettingDate: "удачное получение расписания"
            },
            connectorGds: {
                menu: "Расписание в GDS BETA",
                title: "Расписание в GDS.",
                subtitle: `Вдохновившись <a class="secondaryA" href="https://habr.com/ru/post/502378/" target="_blank">статьей</a> о анализе загруженности расписаний, мы добавили возможность выгрузки данных расписания в GDS, что стало отличным дополнением к <a class="secondaryA" href="https://www.bitrix24.ru/apps/?app=mywebstor.konstruktor_otchetov_i_dashbordov_v_google_data_studio" target="_blank">нашему коннектору GDS</a>.`,
                warning: `Внимание! У распределений созданных до обновления на 5 версию, будет неверно отображаться дата окончания рабочего дня.<br>
                <a class="secondaryA" target="_blank" href="https://datastudio.google.com/datasources/create?connectorId=AKfycbyqlDc6S_A_C6ErH-en76IEUNUUIPmtTiI2lfLvJPanx-BqZWMwa7gEYY790o6TISBb">Ссылка на коннектор</a>`,
                token: "Ваш токен",
            }
        }
    },
    onlineForm: {
        stepper: {
            setFilial: "Выбор филиала",
            setNapravl: "Выберите дату и время",
            inputPersonalData: "Ввод персональных данных"
        },
        setFilial: {
            title: "Выберите филиал"
        },
        setNapravl: {
            duration: "Оценочная продолжительность: {minutes} минут",
            selectMonth: "Выберите месяц",
            selectTime: "Выберите время"
        },
        setPersonalData: {
            confirm: "Подтвердите запись на {date}, на {minutes} минут{filial}",
            successTitle: "Запись успешна",
            successSubtitle: "Вы успешно записались на {date}, на {minutes} минут{filial}",
            successMore: "Записаться еще",
            phone: "Номер телефона",
            lastName: "Фамилия",
            name: "Имя",
            secondName: "Отчество",
            submit: "Подтвердить"
        }
    }
};

export default locale;